import { makeAutoObservable, runInAction } from 'mobx';
import { getEnv } from 'mobx-easy';

import { RootEnv } from 'app/stores/config/CreateStore';

import { Materials } from '../../../models/CustomerModels';

export class Layout {
  materials: Materials;
  routesState: Record<number, boolean> = {};
  sidebarOpen: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  toggleSidebar = () => {
    this.sidebarOpen = !this.sidebarOpen;
  };

  toggleRoute = (index: number) => {
    this.routesState[index] = !this.routesState[index];
  };

  setRouteState = (index: number, value: boolean) => {
    this.routesState[index] = value;
  };

  async loadMaterials(): Promise<Materials | boolean> {
    try {
      const { customerService } = getEnv<RootEnv>();
      const { data } = await customerService.getCustomersMaterials();

      runInAction(() => {
        this.materials = data;
      });

      return this.materials;
    } catch {
      return false;
    }
  }
}
